import {waitForEntryOrTemplateSaved} from 'notebook/entries/BaseEntryUtil';
import notifications from 'notifications';
import * as logging from 'util/Logging';

const WAIT_FOR_ENTRY_SAVED_SECONDS = 30;
const WAIT_FOR_ENTRY_SAVED_INTERVAL_MS = 500;

export default async function waitForEntrySaved(fileId: string): Promise<boolean> {
  // Wait for save to ensure run is linked to the entry for permissions.
  // This is sort of a hack and ideally our data model would not require save to have gone through.
  const saved = await waitForEntryOrTemplateSaved(
    fileId,
    WAIT_FOR_ENTRY_SAVED_INTERVAL_MS,
    WAIT_FOR_ENTRY_SAVED_SECONDS
  );
  if (!saved) {
    logging.info(
      `Saving entry took more than ${WAIT_FOR_ENTRY_SAVED_SECONDS} seconds. This is not urgent; the user has been informed to retry their lab automation action shortly.`,
      {
        extra: {entryId: fileId},
      }
    );
    notifications.error(
      `Action requires the entry to be saved. Please wait until the entry is saved before trying again.`
    );
    return false;
  }
  return true;
}
